"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getChordProgressionCalculator = void 0;
const majorProgressions = [
    [0, 1, 2, 3, 4, 5, 6], // I => any
    [0, 1, 4, 6], // ii => V, vii*
    [0, 2, 3, 5], // iii => IV, vi
    [0, 1, 3, 4, 6], // IV => ii, V, vii*
    [0, 4, 5], // V => vi
    [0, 1, 2, 3, 4, 5], // vi => ii, iii, IV, V
    [0, 6], // vii* => I
];
const minorProgressions = [
    [0, 1, 2, 3, 4, 5, 6], // i => any
    [0, 1, 4, 6], // ii* => V, vii*
    [0, 2, 3, 5, 6], // III => iv, VI, vii*
    [0, 3, 4, 6], // iv => V, vii*
    [0, 4, 5], // V => VI
    [0, 2, 3, 4, 5, 6], // VI => III, iv, V, vii*
    [0, 6], // vii* => i
];
/**
 * Calculates chord progressions. This class is immutable.
 */
class ChordProgressionCalculatorImpl {
    constructor(key) {
        this.key = key;
        this.progressions = (key.modeAlias === "minor" ? minorProgressions : majorProgressions);
    }
    get rootChord() {
        return this.getChordAt(0);
    }
    getChordAt(num) {
        return this.key.chords[num];
    }
    getNextChords(chord) {
        let num = this.getChordNumber(chord);
        // If it's not a valid chord set to root
        if (num < 0) {
            num = 0;
        }
        const progs = this.progressions[num];
        // Build list of chords
        const nextChords = [];
        for (let i = 0; i < progs.length; i++) {
            nextChords.push(this.key.chords[progs[i]]);
        }
        return nextChords;
    }
    getChordNumber(chord) {
        return this.key.chords.findIndex(c => c.name === chord.name);
    }
}
/**
 * Gets an instance of a chord progrerssion calculator
 * @param scale The scale to use, must be either major or minor
 */
function getChordProgressionCalculator(scale) {
    if (scale.normalizedMode !== "ionian" && scale.normalizedMode !== "aeolian") {
        throw new Error("Only major and minor scales are supported");
    }
    return new ChordProgressionCalculatorImpl(scale);
}
exports.getChordProgressionCalculator = getChordProgressionCalculator;
//# sourceMappingURL=chord-progression-calculator.js.map